import { useContext, useEffect } from 'react';

import { SubjectsContext } from '../globalContext/subjects/subjectsProvider';
import useFetch from '../services/apiService/useFetch';
import useSaveCurrentChapter from './useSaveCurrentChapter';
import API_ENDPOINTS from '../consts/endpoint';
import {
  setAllSubjects,
  setSelectedSubject,
} from '../globalContext/subjects/subjectsActions';
import { urlService } from '../services/urlService';
import { SubjectFormatInterface, SubjectsDetails } from '../interface';
import { API_RESPONSE_STATUS_CODE, URL_PARAMS } from '../consts/constants';

const useGetAllPurchasedSubjects = () => {
  const [subjectInfo, dispatchSubjectsInfo] = useContext(SubjectsContext);
  const { saveCurrentChapterDetails } = useSaveCurrentChapter();

  const {
    fetchData: getPurchasedSubjectsList,
    isLoading: isGettingSubjectsList,
  } = useFetch<SubjectsDetails>({
    url: `${API_ENDPOINTS.COURSE_SUBJECTS}`,
    otherOptions: {
      skipApiCallOnMount: true,
    },
  });

  const savePurchasedSubjectsList = async () => {
    const currentChapterResponse = await getPurchasedSubjectsList({});
    if (currentChapterResponse?.status === API_RESPONSE_STATUS_CODE.SUCCESS) {
      dispatchSubjectsInfo(
        setAllSubjects({
          allSubjectsList: currentChapterResponse?.data,
        }),
      );
      const firstSubject = currentChapterResponse?.data?.[0];

      const subjectQueryParamValue = urlService.getQueryStringValue(
        URL_PARAMS.SUBJECT_ID,
      );

      if (subjectQueryParamValue) {
        const subjectItem = currentChapterResponse?.data?.find(
          (item: SubjectFormatInterface) =>
            item.subject_id === +subjectQueryParamValue,
        );
        if (subjectItem) {
          dispatchSubjectsInfo(
            setSelectedSubject({
              selectedSubject: subjectItem,
            }),
          );
          return;
        }
        dispatchSubjectsInfo(
          setSelectedSubject({
            selectedSubject: firstSubject,
          }),
        );
        return;
      }
      dispatchSubjectsInfo(
        setSelectedSubject({
          selectedSubject: firstSubject,
        }),
      );
    }
  };

  useEffect(() => {
    if (subjectInfo?.selectedSubject?.subject_id) {
      saveCurrentChapterDetails({
        subject_id: subjectInfo?.selectedSubject?.subject_id,
      });
    }
  }, [subjectInfo?.selectedSubject?.subject_id]);

  return { isGettingSubjectsList, savePurchasedSubjectsList };
};

export default useGetAllPurchasedSubjects;
